import "./Toaster.scss";

import React, { Component } from "react";
import { Toast, ToastBody } from "reactstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

interface Props {
  toasterClass?: string;
  showToaster: boolean;
  toasterDuration?: number;
}

class Toaster extends Component<Props> {
  static defaultProps: { toasterClass: string; toasterDuration: 3000 };

  render() {
    return (
      <div>
        <Toast
          className={
            this.props.showToaster ? this.props.toasterClass : "d-none"
          }
        >
          <ToastBody>
            {this.props.children}
            <span className="close-toaster">
              <FontAwesomeIcon icon={faTimes as IconDefinition} />
            </span>
          </ToastBody>
        </Toast>
      </div>
    );
  }
}

Toaster.defaultProps = {
  toasterClass: "toaster toaster-bg-success",
  toasterDuration: 3000,
};

export default Toaster;
